import React, { useEffect } from 'react';
import { css } from '@emotion/core';
const { isProduction } = require('gatsby-theme-apollo/src/util/environments');

export const NitroAd = ({placementId, adData, style}) => {
  useEffect(() => {
    let fullAdData = { 
      demo: !isProduction,
      ...adData
    };

    // need to make sure there aren't stale anchor ads laying around.. yay for dom injections..
    let anchorAds = document.querySelectorAll("div[id^='gh-anchor']");
    if (anchorAds.length > 1) {
      document.querySelectorAll("div[id^='gh-anchor']+div").forEach(e => e.parentNode.removeChild(e));
      anchorAds.forEach(e => e.parentNode.removeChild(e));
    }
    
    window['nitroAds'].createAd(placementId, fullAdData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div id={placementId} style={style} />
  );
};

export const AdBox = ({placementId}) => {
  return (
    <div
      style={{
        display: `flex`,
        width: `100%`,
        height: `auto`
      }}
    >
      <NitroAd 
        placementId = {placementId}
        adData={{
          refreshLimit: 10,
          refreshTime: 30,
          renderVisibleOnly: true,
          refreshVisibleOnly: true,
          sizes: [
            ['300', '250']
          ],
          report: {
            enabled: true,
            wording: 'Report Ad',
            position: 'top-right'
          }
        }}
        style = {{
          width: `100%`,
          margin: `15px 0px`,
          minHeight: `250px`
        }}
      />
    </div>
  );
};

export const AdMobileBanner = ({placementId}) => {
  return (
    <div
      css={css`
        @media (min-width: 320px) and (max-width: 767px) {
          width: 100%;
          height: 68px;
        }
      `}
    >
      <NitroAd 
        placementId = {placementId}
        adData={{
          "refreshLimit": 10,
          "refreshTime": 30,
          "renderVisibleOnly": false,
          "refreshVisibleOnly": true,
          "sizes": [
            ["320","50"]
          ],
          "report": {
            "enabled": true,
            "wording": "Report Ad",
            "position": "bottom-right"
          },
          "mediaQuery": "(min-width: 320px) and (max-width: 767px)"
        }}
      />
    </div>
  );
};


export const AdLeaderboard = ({placementId}) => {
  return (
    <div
      css={css`
        @media (min-width: 768px) {
          width: 100%;
          height: 108px;
        }
      `}
    >
      <NitroAd 
        placementId = {placementId}
        adData={{
          "refreshLimit": 10,
          "refreshTime": 30,
          "renderVisibleOnly": false,
          "refreshVisibleOnly": true,
          "sizes": [
            [
              "728",
              "90"
            ]
          ],
          "report": {
            "enabled": true,
            "wording": "Report Ad",
            "position": "bottom-right"
          },
          "mediaQuery": "(min-width: 768px)"
        }}
      />
    </div>
  );
};

export const AdMobileAnchor = ({placementId, anchorType, offset}) => {
  return (
    <div>
      {/* these styles are needed to offset the anchor ad render above the navbar */}
      <style>{
        "#"+ placementId + " {\n" +
        "    bottom: " + offset + "px !important;\n" +
        "}\n" +
        "#" + placementId + " + div {\n" +
        "    bottom: " + (50 + +offset) + "px !important;\n" +
        "}"
      }</style>
      <NitroAd 
        placementId = {placementId}
        adData={{
          format: 'anchor',
          anchor: {anchorType},
          refreshLimit: 10,
          refreshTime: 30,
          "refreshVisibleOnly": false,
          "renderVisibleOnly": false,
          sizes: [[320, 50]],
          report: {
            enabled: true,
            wording: 'Report Ad',
            position: 'top-right'
          },
          mediaQuery: '(max-width: 767px)'
        }}
      />
    </div>
  );
};

export const AdVideo = ({placementId}) => {
  return (
    <div>
      <NitroAd 
        placementId = {placementId}
        adData={{
          "format": "video-ac",
          "mediaQuery": "(min-width: 1025px)"
        }}
      />
    </div>
  );
};